import { Box, makeStyles } from '@material-ui/core'
import Icon from '@mdi/react'
import React from 'react'
import { mdiTrashCanOutline } from '@mdi/js'
import FileUploadIcon from '../../../assets/svg/file-upload.svg'
import classNames from 'classnames'
import { CustomSwitch } from '../../root/components/common/switch'

const useStyles = makeStyles(theme => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center'
    },
    wrapperPointer: {
        cursor: 'pointer',
        alignItems: 'center',
        marginBottom: 10
    },
    header: {
        fontWeight: 700,
        fontSize: 15,
        color: theme.gray,
        opacity: 0.4,
        marginBottom: 10
    },
    itemLabel: {
        fontWeight: 500,
        fontSize: 15,
        color: theme.primary
    },
    iconWrapper: {
        width: 58,
        paddingLeft: 12,
        paddingRight: 12,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    switch: {
        '& .MuiSwitch-thumb': {
            backgroundColor: theme.primary
        }
    },
    wrapperHidden: {
        position: 'relative'
    },
    hiddenInput: {
        opacity: 0,
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        cursor: 'pointer'
    }
}))

export function FloorPlanDrawer({
    locale,
    theme,
    isShowSerialNumber,
    handleSerialNumberChange,
    isShowDeviceName,
    handleShowDeviceNameChange,
    handleReplace,
    handleDelete
}) {
    const classes = useStyles()

    return (
        <>
            <Box className={classes.header}>
                {locale.locations.floorPlanBtns.appearance}
            </Box>
            <Box className={classes.wrapper}>
                <CustomSwitch
                    className={classes.switch}
                    isChecked={isShowSerialNumber}
                    handleChange={handleSerialNumberChange}
                />
                <div className={classes.itemLabel}>
                    {locale.locations.floorPlanBtns.serialLabel}
                </div>
            </Box>
            <Box className={classes.wrapper} style={{ marginBottom: 20 }}>
                <CustomSwitch
                    className={classes.switch}
                    isChecked={isShowDeviceName}
                    handleChange={handleShowDeviceNameChange}
                />
                <div className={classes.itemLabel}>
                    {locale.locations.floorPlanBtns.nameLabel}
                </div>
            </Box>
            <Box className={classes.header}>
                {locale.locations.floorPlanBtns.actions}
            </Box>
            <Box
                className={classNames(classes.wrapper, classes.wrapperPointer)}
                onClick={handleDelete}
            >
                <div className={classes.iconWrapper}>
                    <Icon
                        path={mdiTrashCanOutline}
                        color={theme.primary}
                        size={0.8}
                    />
                </div>
                <div className={classNames(classes.itemLabel)}>
                    {locale.locations.floorPlanBtns.delete}
                </div>
            </Box>
            <Box
                className={classNames(
                    classes.wrapper,
                    classes.wrapperPointer,
                    classes.wrapperHidden
                )}
            >
                <div className={classes.iconWrapper}>
                    <img src={FileUploadIcon} alt="file upload" />
                </div>
                <div className={classNames(classes.itemLabel)}>
                    {locale.locations.floorPlanBtns.replace}
                </div>
                <input
                    className={classes.hiddenInput}
                    type="file"
                    accept="image/jpg, image/jpeg, image/png, application/pdf"
                    onChange={handleReplace}
                />
            </Box>
        </>
    )
}
